import api from '@/integrations/axios/axios-instance'

export interface EmailServiceStatus {
  isOnline: boolean
  reauthRequired: boolean
  lastChecked: string
}

export interface NotifyAdminRequest {
  message?: string
  userEmail: string
  userName: string
}

export interface NotifyAdminResponse {
  success: boolean
  message: string
}

const EMAIL_SERVICE_BASE_URL = '/email-service'

export const emailServiceApi = {
  async getStatus(): Promise<EmailServiceStatus> {
    const response = await api.get(
      `${EMAIL_SERVICE_BASE_URL}/email-service-status`,
    )
    return response.data
  },

  async notifyAdmin(data: NotifyAdminRequest): Promise<NotifyAdminResponse> {
    const response = await api.post(
      `${EMAIL_SERVICE_BASE_URL}/notify-admin`,
      data,
    )
    return response.data
  },
}
